module.exports = __webpack_public_path__ + "static/media/less.85928ab6.png";